import React from 'react';
import { bool, shape, string } from 'prop-types';

const AgroOperationStatusColor = ({
  className = '',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.1 5L14.97 8.17L13.9 7.09L12.5 8.5L14.97 11L19.5 6.41L18.1 5Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M16 15C19.866 15 23 11.866 23 8C23 4.13401 19.866 1 16 1C12.134 1 9 4.13401 9 8C9 11.866 12.134 15 16 15ZM16 13C18.7614 13 21 10.7614 21 8C21 5.23858 18.7614 3 16 3C13.2386 3 11 5.23858 11 8C11 10.7614 13.2386 13 16 13Z" fill="currentColor" />
    <path d="M2 14.001C2 11.481 3.17 9.23098 5 7.77098V9.50098H7V4.50098H1V6.50098H3.4C1.32 8.33098 0 11.011 0 14.001C0 19.191 3.95 23.451 9 23.951V21.931C5.06 21.441 2 18.071 2 14.001Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M8.52736 12.0543C7.42528 11.2962 6.12098 11.0654 5.05962 11.002C4.77735 10.9851 4.50113 11.0885 4.29936 11.2867C4.09759 11.4848 3.98914 11.7591 4.00086 12.0416C4.06664 13.6276 4.35103 15.6662 5.52416 17.0841L5.52867 17.0895C6.48942 18.2342 7.80691 18.7072 9 18.8976V21.0002H11V16.9111C11.9044 16.7974 12.8567 16.5858 13.7714 16.2049C11.5102 15.5921 9.62304 14.0695 8.52736 12.0543ZM8.89925 16.8415C8.7562 15.779 8.46483 14.8334 7.93714 14.1939C7.47956 13.6503 6.83747 13.332 6.10075 13.1589C6.24381 14.2214 6.53518 15.1669 7.06287 15.8064C7.52045 16.3501 8.16254 16.6684 8.89925 16.8415Z" fill="currentColor" />
    <path d="M17.6506 16.3398C17.1749 17.8883 16.2386 19.236 15 20.231V18.501H13V23.501H19V21.501H16.6C18.3095 19.9969 19.5057 17.9187 19.8775 15.5661C19.185 15.9217 18.4373 16.185 17.6506 16.3398Z" fill="currentColor" />
  </svg>
);

AgroOperationStatusColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default AgroOperationStatusColor;
